/*
 * @Descripttion: 封装数据请求
 * @Author: juanjuanhui
 * @Date: 2021-05-17 09:25:08
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-09-19 10:36:59
 */
import request from "./request";
import axios from "axios";
const http = {
  /**
   * @descripttion: GET请求
   * @Author: juanjuanhui
   * @Date: 2021-06-23 21:10:32
   * @param {String} url 请求地址
   * @param {Object} params 请求参数
   * @return {*}
   */
  get(url, params) {
    const config = {
      method: "get",
      url,
    };
    if (params) config.params = params;
    return request(config);
  },
  /**
   * @descripttion: POST请求
   * @Author: juanjuanhui
   * @Date: 2021-06-23 21:09:01
   * @param {String} url 请求地址
   * @param {Object} params 请求参数
   * @return {*}
   */
  post(url, params, contentType) {
    const config = {
      method: "post",
      url,
    };
    if (params) config.data = params;
    if (contentType) config.contentType = contentType;
    return request(config);
  },
  /**
   * @description: 通过blob 下载文件
   * @Author: quwandong
   * @Date: 2023-02-23 21:09:01
   * @param {*} url
   * @param {*} params
   * @returns
   */
   exportWithBlob(url, params) {
    return axios({
      method: "post",
      url,
      headers: {
        Accesstoken:localStorage.getItem("accessToken"),
      },
      data: params,
      responseType: "blob",
    });
  },
};
export default http;
